import breakpoints from '@/theme/constants/breakpoints';
import pxToRem from '@/theme/helpers/pxToRem';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledRatingLine = styled.p`
  ${typography.Body1}

  @media only screen and ${breakpoints.device.l} {
    height: ${pxToRem(26)};
  }
`;
